export default {
  serviceOrders: 'Activities',
  profile: 'Profile',
  person: 'People',
  location: 'Locations',
  fleet: 'Fleets',
  users: 'Users',
  welcomeAssistant: 'Hello! I am the BTime virtual assistant. How can I help you today?',
  btimeAI: 'Btime AI',
  satisfactionSurvey: 'Satisfaction Survey',
  chatSupport: 'Chat Support',
  dashboard: 'Dashboard',
  processes: 'Processes',
  map: 'Map',
  forms: 'Forms',
  nonCompliance: 'Non-compliance',
  nonComplianceServiceOrders: 'Activity non-compliances',
  nonComplianceForms: 'Form non-compliances',
  availability: 'Availability',
  dynamicServiceOrders: 'Dynamic Activities',
  stocks: 'Stock',
  settings: 'Settings',
  generalRegistrations: 'General registrations',
  checklists: 'Questionnaires',
  masks: 'Masks',
  assets: 'Assets',
  segmentation: 'Segmentation',
  integrations: 'Integrations',
  webhook: 'Webhook',
  modulesAndPermissions: 'Modules and permissions',
  createPlaceType: 'Create place type',
  projects: 'Projects',
  systemLogs: 'System logs',
  triggerHistory: 'Trigger history',
  clearCache: 'Clear cache',
  changePassword: 'Change password',
  logout: 'Logout'
}
